var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2962FF",
    d: "M19.33 8.04a6 6 0 0 0 0 11.92 8 8 0 1 1 0-11.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostMarket);
export default __webpack_public_path__ + "static/media/PostMarket.3ff0d3c37e563abe66df602e3b346f41.svg";
export { ForwardRef as ReactComponent };